import MarketingPage from './marketing-page/MarketingPage';

function App() {
  return <MarketingPage />;
}

export default App;
